import { PatchDataWrapper, PostDataWrapper } from '@diamond/shared/data-access';
import { apiInstance } from '@diamond/shared/utils';
import { useAuthStore } from '@diamond/sol-admin/features/auth';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deleteBanner } from '../api';

export const BANNERS_QUERY_KEY = 'Banners';

export function useUploadBannerImage() {
  const session = useAuthStore();
  const { postData } = PostDataWrapper(
    '/backoffice/banner/upload',
    session.access_token,
    true,
    'admin'
  );

  return async (file: File) => {
    const formData = new FormData();
    formData.append('file', file, file.name);
    return postData(formData, {
      headers: {
        authorization: `Bearer ${session.access_token}`,
        'Content-Type': 'multipart/form-data',
      },
    });
  };
}

export function useUploadShiptoCsv() {
  const session = useAuthStore();
  const { postData } = PostDataWrapper(
    '/backoffice/banner/upload-shipto-csv',
    session.access_token,
    true,
    'admin'
  );

  return async (file: File) => {
    const formData = new FormData();
    formData.append('file', file, file.name);
    return postData(formData, {
      headers: {
        authorization: `Bearer ${session.access_token}`,
        'Content-Type': 'multipart/form-data',
      },
    });
  };
}

export function useCreateBanner() {
  const session = useAuthStore();
  return async (payload: unknown) => {
    return apiInstance(session.access_token).post(
      '/backoffice/banner',
      payload
    );
  };
}

export function useUpdateBanner() {
  const session = useAuthStore();
  const { patchData } = PatchDataWrapper(
    '/backoffice/banner',
    session.access_token
  );
  return async (id: string, payload: unknown) => {
    return patchData(payload, id);
  };
}

type UseDeleteBannerMutationArgs = {
  onSuccess?: () => void;
  onSettled?: () => void;
};

export function useDeleteBannerMutation(args?: UseDeleteBannerMutationArgs) {
  const token = useAuthStore((s) => s.access_token);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => deleteBanner(token, id),
    onSuccess: () => {
      // Refresh banners list without full page reload
      queryClient.invalidateQueries({ queryKey: [BANNERS_QUERY_KEY] });
      args?.onSuccess?.();
    },
    onSettled: () => {
      args?.onSettled?.();
    },
  });
}
